import fetch from 'auth/FetchInterceptor'

const DepartmentService = {}

DepartmentService.fetch = function () {
	return fetch({
		url: '/departments',
		method: 'get'
	})
}

DepartmentService.create = function (data) {
	return fetch({
		url: '/departments',
		method: 'post',
		data
	})
}

DepartmentService.update = function (data) {
	return fetch({
		url: '/departments/' + data.id,
		method: 'put',
		data
	})
}

DepartmentService.delete = function (id) {
	return fetch({
		url: '/departments/' + id,
		method: 'delete',
	})
}

export default DepartmentService;